import React from "react";
import { Col, Container, Row } from "reactstrap";

const ServicesCard = (props) => {
  return (
    <>
      <Col lg={4} md={6}>
        <div
          className={
            props.isShadow
              ? "service-box text-center mt-4 box-shadow"
              : "service-box text-center mt-4"
          }
        >
          <div className="service-icon mb-4">
            <i className={`${props.icon} text-primary`} style={{ fontSize: '3rem' }}></i>
          </div>
          <h5 className="fs-18 mt-4">{props.title}</h5>
          <div className="lighlight-border mt-3"></div>
          <p className="text-muted mt-3">{props.caption}</p>
        </div>
      </Col>
    </>
  );
}

// Services data - Energia Solar

const ServicesData = [
  {
    icon: "mdi mdi-home",
    title: "Instalação Residencial",
    caption:
      "Sistema fotovoltaico personalizado para sua casa. Reduza até 95% da sua conta de luz com energia limpa e renovável.",
  },
  {
    icon: "mdi mdi-office-building",
    title: "Instalação Comercial",
    caption:
      "Soluções para comércios e empresas. Aumente sua competitividade reduzindo custos operacionais com energia solar.",
    isShadow: true,
  },
  {
    icon: "mdi mdi-factory",
    title: "Instalação Industrial",
    caption:
      "Projetos de grande porte para indústrias. Alta potência e eficiência para demandas de grande escala.",
  },
  {
    icon: "mdi mdi-wrench",
    title: "Manutenção Preventiva",
    caption:
      "Acompanhamento e manutenção do seu sistema para garantir máxima eficiência e durabilidade dos equipamentos.",
    isShadow: true,
  },
  {
    icon: "mdi mdi-file-certificate",
    title: "Homologação",
    caption:
      "Cuidamos de toda a documentação e processo de homologação junto à concessionária de energia da sua região.",
  },
  {
    icon: "mdi mdi-calculator-variant",
    title: "Projetos Personalizados",
    caption:
      "Dimensionamento técnico sob medida. Análise completa do seu consumo para máxima economia e retorno do investimento.",
    isShadow: true,
  },
];

const Services = () => {
  return (
    <>
      <section className="section" id="servicos">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}>
              <div className="header-title text-center">
                <p className="text-uppercase text-muted mb-2">
                  Nossos Serviços
                </p>
                <h3>Soluções Completas em Energia Solar</h3>
                <div className="title-border mt-3"></div>
                <p className="text-muted mt-3">
                  Com mais de 6 anos de experiência, oferecemos serviços completos
                  desde o projeto até a instalação e homologação do seu sistema
                  fotovoltaico.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {ServicesData.map((value, idx) => (
              <ServicesCard
                key={idx}
                icon={value.icon}
                title={value.title}
                caption={value.caption}
                isShadow={value.isShadow}
              />
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Services;
